import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { concatMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { ZalamoInlineHelpClientActionTypes, ZalamoInlineHelpClientActions } from './zalamo-inline-help-client.actions';



@Injectable()
export class ZalamoInlineHelpClientEffects {


  loadZalamoInlineHelpClients$ = createEffect(() => this.actions$.pipe(
    ofType(ZalamoInlineHelpClientActionTypes.LoadZalamoInlineHelpClients),
    /** An EMPTY observable only emits completion. Replace with your own observable API request */
    concatMap(() => EMPTY)
  ), { dispatch: false });


  constructor(private actions$: Actions<ZalamoInlineHelpClientActions>) {}

}
